import React, { useState, useRef, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from 'axios';

// ICONOS
import { MdArrowBackIos, MdCreditCard, MdCheckCircle } from 'react-icons/md';
import { FaCcVisa } from 'react-icons/fa';
import { SiMastercard, SiAmericanexpress } from 'react-icons/si';

import useGetTipoCambio from "../hooks/useGetTipoCambio";
import useGetMontoPago from "../hooks/useGetMontoPago";
import useInput from "../hooks/useInput";

import Card from '../components/UI/Card';
import AuthContext from "../context/auth-context";
import { AppContext } from "../services/AppContext";
import useGetPagos from "../hooks/useGetPagos";

//import useGetPermitidoPagar from "../hooks/useGetPermitidoPagar";

const PagoAdmision = () => {

    const authContext = useContext(AuthContext);
    const { appValues, setAppValues } = useContext(AppContext);

    const pagoAdmision = useGetPagos(authContext.token);
    const pagoRealizado = appValues.pagoAdmision === 'APROBADA';
    useEffect(() => {

        if(pagoAdmision !== undefined && pagoAdmision.PAGOS ){

            let estadoPagoAdmision = '';
            pagoAdmision.PAGOS.every(pago => {
                if(pago.ESTADO === "APROBADA"){
                    estadoPagoAdmision = pago.ESTADO;
                    return false;
                }
                return true;
            });

            setAppValues(
                prev => {
                    return {...prev, pagoAdmision: estadoPagoAdmision};
                }
            );
        }
    }, [pagoAdmision, setAppValues]);


    const navigate = useNavigate();

   // const permitido_pagar = useGetPermitidoPagar(authContext.token);

    const tipoCambio = useGetTipoCambio();
    const montoUSD = useGetMontoPago();
    const isMontoValid = montoUSD > 0;

    // INPUT NOMBRE
    const nombreValidacion = value => value !== "";
    const {
        value: nombre,
        isValid: nombreIsValid, 
        isTouched: nombreIsTouched,
        valueChangeHandler: nombreChangeHandler,
        inputBlurHandler: nombreBlurHandler,
        // scrollToDiv: scrollToDivNombre
    } = useInput(nombreValidacion);

    // INPUT TARJETA
    const isNumero = (value) => {
        return ( /^[0-9]+$/.test(value) );
    }

    const[numTarjeta, setNumTarjeta] = useState('');
    const[numTarjetaTouched, setNumTarjetaTouched] = useState(false); 
    const[numTarjetaPos, setNumTarjetaPos] = useState(0);
    const numTarjetaRef = useRef();


    // logo tarjeta
    let tipoTarjeta = "default";
    let logoTarjeta = <MdCreditCard />;
    const numTarjetaDigits = numTarjeta.replace(/\s/g, '');
    // Visa
    if( /^4[0-9]{15}?$/.test(numTarjetaDigits) ){
        tipoTarjeta = "visa";
        logoTarjeta = <FaCcVisa />;
    // Mastercard
    } else if ( /^5[1-5][0-9]{14}$/.test(numTarjetaDigits) || /^2[2-7][0-9]{14}$/.test(numTarjetaDigits) ){
        tipoTarjeta = "mastercard";
        logoTarjeta = <SiMastercard />;
    // Amex
    } else if ( /^3[47][0-9]{13}$/.test(numTarjetaDigits) ){
        tipoTarjeta = "amex";
        logoTarjeta = <SiAmericanexpress />;
    }

    const numIsTarjetaValid = ( numTarjetaDigits.length === 16 && (tipoTarjeta === 'visa' || tipoTarjeta === 'mastercard') ) || ( numTarjetaDigits.length === 15 && (tipoTarjeta === 'amex') );


    const numTarjetaChangeHanlder = (event) => {
        setNumTarjetaPos(event.target.selectionStart);
        //cambiar el set aqui, no?

        const numero = event.target.value.replace(/\s/g, '');
        let formatNumero = "";

        if( numero === "" || (numero.length <= 16 && isNumero(numero)) ){
            for(let i=0; i<numero.length; i+=4){
                formatNumero += numero.substring(i,i+4) + "    ";
            }
            formatNumero = formatNumero.substring(0,formatNumero.length-4);
            setNumTarjeta( formatNumero );
        }
    }

    const numTarjetaBlurHandler = () => {
        setNumTarjetaTouched(true);
    };

    useEffect(() => {
        // posible solucion: poner el cursor al final siempre despues del blur

        if(numTarjetaPos > 4 && numTarjetaPos <= 7){
            numTarjetaRef.current.setSelectionRange(9,9);
        } else if(numTarjetaPos > 12 && numTarjetaPos <= 16){
            numTarjetaRef.current.setSelectionRange(17,17);
        } else if(numTarjetaPos > 20 && numTarjetaPos <= 24){
            numTarjetaRef.current.setSelectionRange(25,25);
        } else {
            numTarjetaRef.current.setSelectionRange(numTarjetaPos,numTarjetaPos);
        }

    }, [numTarjetaPos]);


    // INPUT FECHA EXPIRACION
    const arrMes = ["01","02","03","04","05","06","07","08","09","10","11","12"];

    const currYear = new Date().getFullYear();
    const arrYear = [currYear,currYear+1,currYear+2,currYear+3,currYear+4,currYear+5,currYear+6,currYear+7,currYear+8,currYear+9,currYear+10];

    const mesValidacion = value => parseInt(value) >= 0 && parseInt(value) <= 12;
    const {
        value: mes,
        isValid: mesIsValid,
        isTouched: mesIsTouched,
        valueChangeHandler: mesChangeHandler,
        inputBlurHandler: mesBlurHandler
    } = useInput(mesValidacion);

    const yearValidacion = value => parseInt(value) >= new Date().getFullYear() && parseInt(value) <= (new Date().getFullYear()+10);
    const {
        value: year,
        isValid: yearIsValid,
        isTouched: yearIsTouched,
        valueChangeHandler: yearChangeHandler,
        inputBlurHandler: yearBlurHandler
    } = useInput(yearValidacion);


    // INPUT CCV
    const [numCCV, setNumCCV] = useState("");
    const [numCCVTouched, setNumCCVTouched] = useState(false);

    const numCCVIsValid = (numCCV.length === 3 || numCCV.length === 4) && isNumero(numCCV);

    const numCCVChangeHandler = (event) => {
        if( event.target.value === "" || (event.target.value.length <= 4 && isNumero(event.target.value)) ){
            setNumCCV(event.target.value);
        }
    }

    const numCCVBlurHandler = () => {
        setNumCCVTouched(true);
    };

    let formIsValid = false;

    if(
        nombreIsValid &&
        numIsTarjetaValid &&
        mesIsValid &&
        yearIsValid &&
        numCCVIsValid && 
        isMontoValid
    )
    {
        formIsValid = true;
    }

    // SUBMIT HANLDER
    const formSubmitHanlder = async(event) => {
        event.preventDefault();

        nombreBlurHandler();
        numTarjetaBlurHandler();
        mesBlurHandler();
        yearBlurHandler();
        numCCVBlurHandler();

        if(!formIsValid)
            return;
        
        const form_data = new FormData();
        form_data.append('idToken', authContext.token);
        form_data.append('pagoAdmision', 1);
        form_data.append('nombre', nombre);
        form_data.append('tarjeta', numTarjetaDigits);
        form_data.append('mm', mes);
        form_data.append('yyyy', year);
        form_data.append('cvv', numCCV);



        const form_data_pago = new FormData();
        form_data_pago.append('idToken', authContext.token);
        form_data_pago.append('permitido_pagar', 1);

        
      //  var permitido_pagar=0;

         axios.post(process.env.REACT_APP_API_URL, form_data_pago)
         .then(res => {
            const result = res.data;
              //  
              if(result===0){

                Swal.fire({
                    icon: 'error',
                    titleText: "Pago no registrado.",
                  //  text: "No es posible realizar el pago dado que ya existe un pago registrado en esta aplicación. Favor revise la pestaña 'Mis operaciones de pago'. Cualquier duda comuníquese al correo academicoposgrado@ufm.edu",
                    text: "No es posible realizar el pago dado que ya existe un pago registrado en esta aplicación. Favor revisar la pestaña 'Mis operaciones de pago'. Cualquier duda comuníquese al correo academicoposgrado@ufm.edu",
                    showConfirmButton: false,
                    showDenyButton: true,
                    denyButtonText: "Aceptar",
                    backdrop: true,
                    allowOutsideClick: false
                });

              }
              else{
                axios.post(process.env.REACT_APP_API_URL, form_data)
                .then(res => {
                    const result = res.data;
    
                    if( result.STATUS && result.STATUS === 'SUCCESS' && result.MESSAGE ){
                        Swal.fire({
                            icon: 'success',
                            title: result.MESSAGE,
                            showConfirmButton: false,
                            timer: 4000
                        });
                        navigate('/pagos', { replace: true });
    
                    } else if( result.STATUS && result.STATUS === 'ERROR' && result.ERROR && result.ERROR.ID && result.ERROR.MESSAGE ){
                        Swal.fire({
                            icon: 'error',
                            titleText: "¡Error!",
                            text: result.ERROR.MESSAGE,
                            showConfirmButton: false,
                            showDenyButton: true,
                            denyButtonText: "Aceptar",
                            backdrop: true,
                            allowOutsideClick: false
                        });
    
                    } else {
                        Swal.fire({
                            icon: 'error',
                            titleText: "¡Error!",
                            text: "Ocurrió un error desconocido. Inténtelo de nuevo más tarde.",
                            showConfirmButton: false,
                            showDenyButton: true,
                            denyButtonText: "Aceptar",
                            backdrop: true,
                            allowOutsideClick: false
                        });
                    }
    
                })
                .catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrió un problema, intentelo más tarde',
                        showConfirmButton: false,
                        timer: 3500
                    });
                    navigate('/', { replace: true });
                });
              }
             

            /*  console.log(res);
            // permitido_pagar=res;
            permitido_pagar =res.data;
            console.log(permitido_pagar);*/
         })
         .catch((error) => {
             console.log(error)
             Swal.fire({
                 icon: 'error',
                 title: 'Ocurrió un problema, intentelo más tarde',
                 showConfirmButton: false,
                 timer: 3500
             });
         })

      // console.log(permitido_pagar);

       // permitido_pagar=0;
      /*  if(permitido_pagar===0){


            Swal.fire({
                icon: 'error',
                titleText: "El pago ya fue realizado",
                text: " No es posible realizar el pago pues ya existe uno registrado en esta aplicación. Favor revise la pestaña de Mis pagos. Cualquier duda escribir a academicoposgrado@ufm.edu",
                showConfirmButton: false,
                showDenyButton: true,
                denyButtonText: "Aceptar",
                backdrop: true,
                allowOutsideClick: false
            });

        }

        else {*/


        //}

    }

    return (
        <>
            <div className="row py-5">
                <div className="col-lg-8 offset-lg-2 mt-2">
                    {/* BUTTON REGRESAR */}
                    <Link className="btn btn-outline-light border border-2 border-light shadow" style={{fontWeight: "500"}} to='/'>
                        <MdArrowBackIos/> Regresar
                    </Link>
                    &nbsp;
                    {/* BUTTON MIS PAGOS */}
                    <Link className="btn btn-outline-light border border-2 border-light shadow" style={{fontWeight: "500"}} to='/pagos'>
                        Mis operaciones de pago
                    </Link>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-8 offset-lg-2">
                    <Card>
                        <div className="card-body">

                            <form className="row mt-4 mb-4" onSubmit={formSubmitHanlder}>
                                
                                {/* TITULO */}
                                <div className="col-md-10 offset-md-1">
                                    <h1 className="display-6 text-center text-secondary" style={{fontSize: '1.75rem', userSelect: 'none'}}>
                                        Pago de admisión
                                    </h1>
                                    <div className="text-danger pb-3"><hr /></div>
                                </div>

                                <div className="col-md-6 border-end border-dark-subtle">
                                    <div className="row">

                                        <div className="col-md-10 offset-md-1 border-bottom">
                                            <h1 className="display-6 text-black-50" style={{fontSize: '1.5rem'}}>Detalles de pago</h1>
                                        </div>

                                        {/* NOMBRE TARJETA */}
                                        <div className="col-md-10 offset-md-1 my-3">
                                            <label className="form-label text-black-50" htmlFor="nombreTarjeta" style={{userSelect: "none"}}>Nombre</label>
                                            <input 
                                                type="text" 
                                                name="nombreTarjeta" 
                                                className={`form-control form-control-sm shadow-sm ${nombreIsTouched ? ((nombreIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                                value={nombre}
                                                onChange={nombreChangeHandler}
                                                onBlur={nombreBlurHandler}
                                                placeholder="Nombre" 
                                                autoComplete='off'/>
                                            <div className="invalid-feedback">
                                                Campo obligatorio
                                            </div>
                                        </div>

                                        {/* NUMERO TARJETA */}
                                        <div className="col-md-10 offset-md-1 mb-3">
                                            <label htmlFor="tarjetaTest" className="form-label text-black-50">Número de tarjeta</label>  
                                            <div className="input-group">
                                                <span className="input-group-text text-secondary shadow-sm">
                                                    {logoTarjeta}
                                                </span>
                                                <input 
                                                        type="text" 
                                                        name="numeroTarjeta"
                                                        className={`form-control form-control-sm shadow-sm ${numTarjetaTouched ? ((numIsTarjetaValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                                        ref={numTarjetaRef}
                                                        value={numTarjeta}
                                                        onChange={numTarjetaChangeHanlder}
                                                        onBlur={numTarjetaBlurHandler}
                                                        placeholder="0000     0000     0000     0000" 
                                                        style={{paddingLeft: '1.4rem'}}
                                                        autoComplete="off" />
                                                <div className="invalid-feedback">
                                                    Debe ingresar un número de tarjeta válido
                                                </div>
                                            </div>
                                        </div>

                                        {/* FECHA EXPIRACION */}
                                        <div className="col-md-10 offset-md-1">
                                            <label className="form-label text-black-50" htmlFor="expiracionMes" style={{userSelect: "none"}}>Expiración:</label>
                                        </div>
                                        <div className="col-md-4 offset-md-1 mb-3">
                                            <select 
                                                name="expiracionMes" 
                                                className={`form-select form-select-sm shadow-sm ${mesIsTouched ? ((mesIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                                value={mes}
                                                onChange={mesChangeHandler}
                                                onBlur={mesBlurHandler}>
                                                <option value={"MM"} hidden>MM</option>
                                                {
                                                    arrMes.map((mes) => (
                                                        <option key={`month_${mes}`} value={mes}>{mes}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                        <div className="col-md-1 text-black-50 display-6" style={{fontSize: '1.4rem', userSelect: 'none'}}>/</div>
                                        <div className="col-md-5 mb-3">
                                            <select 
                                                name="fechaExpiracionAnio" 
                                                className={`form-select form-select-sm shadow-sm ${yearIsTouched ? ((yearIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                                value={year}
                                                onChange={yearChangeHandler}
                                                onBlur={yearBlurHandler}>
                                                <option value={"YYYY"} hidden>YYYY</option>
                                                {
                                                    arrYear.map((year) => (
                                                        <option key={`year_${year}`} value={year}>{year}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>

                                        {/* CVV */}
                                        <div className="col-md-4 offset-md-1 mb-3">
                                            <label htmlFor="cvv" className="form-label text-black-50">CVV</label>
                                            <input 
                                                name="cvv" 
                                                type="text" 
                                                className={`form-control form-control-sm shadow-sm ${numCCVTouched ? ((numCCVIsValid) ? 'is-valid' : 'is-invalid') : ''}`} 
                                                value={numCCV}
                                                onChange={numCCVChangeHandler}
                                                onBlur={numCCVBlurHandler}
                                                placeholder="- - -" />
                                            <div className="invalid-feedback text-nowrap">
                                                Código inválido
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-6" style={{ userSelect: 'none' }}>
                                    <div className="row">

                                        <div className="col-md-10 offset-md-1 border-bottom">
                                            <h1 className="display-6 text-black-50" style={{fontSize: '1.5rem'}}>Monto a pagar</h1>
                                        </div>

                                        <div className="col-md-10 offset-md-1 mt-3 mb-4">
                                            <h1 className="display-6 text-dark" style={{fontSize: '1.75rem'}}>US$ {montoUSD}</h1>
                                        </div>

                                        <div className="col-md-10 offset-md-1">
                                            <ul className="lead fs-6 ps-3" style={{ textAlign: "justify" }}>
                                                <li>Su cuenta será debitada en quetzales bajo el nombre "<i>Universidad Francisco Marroquín</i>".</li>
                                                <br />
                                                <li> El pago no es reembolsable.</li>
                                                <br />
                                                <li>Si su tarjeta de crédito fue emitida en un país diferente a Guatemala se utiliza la tasa de cambio local en el momento de la transacción.</li>
                                                <br />
                                                <li>Tasa de cambio: US$ 1.00 = Q {tipoCambio}</li>
                                            </ul>
                                        </div>

                                        {/* SUBMIT */}
                                        <div className="col-md-10 offset-md-1 text-center my-3">
                                            <button className={`btn btn-danger fw-light ${ formIsValid && !pagoRealizado ? '':'disabled' }`} type="submit">Pagar</button>
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-10 offset-md-1 pt-5 border-top" style={{ userSelect: 'none', textAlign: 'justify' }}>
                                    <p className="lead">Sitio Seguro <span className="text-success"><MdCheckCircle /></span></p>
                                    <p className="text-black-50 fst-italic">La Universidad Francisco Marroquín cuenta con un Certificado SSL de 128-bit, el cual provee el mayor nivel existente de seguridad al realizar sus transacciones con tarjeta de crédito.</p>
                                </div>

                            </form>

                        </div>
                    </Card>
                </div>
            </div>

        </>
    );
};

export default PagoAdmision;